
<template>

	<b-modal :id="id" size="xl" @show="reset" @hidden="reset" :ok-disabled="okDisabled" title="Добавить информацию о высоте этажа" @ok="ok" ok-title="Добавить" cancel-title="Отменить" cancel-variant="outline-primary-secondary" no-close-on-backdrop>

		<form class="floor-height_add" @submit.stop.prevent="submit">

			<b-form-group label="Код подгруппы" :state="functional_sub_group_state">
				<reference_values ref="functional_sub_group" attr_key="attrs.functional_sub_group" v-model="data.functional_sub_group"
					:state="functional_sub_group_state" aria-describedby="overlap_h__invalid" @input="() => check()"
				/>
				<b-form-invalid-feedback id="overlap_h__invalid" tooltip>Необходимо выбрать код подгруппы</b-form-invalid-feedback>
			</b-form-group>

			<b-form-group :key="field.key" v-for="field in fields" :label="field.label" :label-for="field.key">
				<b-form-input :id="field.key" v-model="data[field.key]"
					type="number"
					@input="(value) => validate(field.key, value)" :formatter="(value) => formatter(field.key, value)"
					:state="states[field.key]" :aria-describedby="field.key + '__invalid'"
				/>
				<b-form-invalid-feedback :id="field.key + '__invalid'" tooltip>Больше 0</b-form-invalid-feedback>
			</b-form-group>

			<b-form-group label="Источник информации" label-for="source">
				<b-form-input id="source" v-model="data.source" />
			</b-form-group>

		</form>

	</b-modal>

</template>

<script>

import { uuid } from "vue-uuid"
import api from "../../../../api"
import reference_values from "../../../widgets/reference"

export default
{
	components :
	{
		reference_values,
	},

	data()
	{
		return {

			id : uuid.v1(),

			service : "cadastral_floor_height",

			data : {},

			functional_sub_group_state : null,

			fields :
			[
				{ label : "Высота этажа, м", key : "floor_h" },
				{ label : "Высота этажа подвала, м", key : "underground_h" },
				{ label : "Коэффициент толщины стен", key : "wall_k" },
				{ label : "Толщина перекрытия, м", key : "overlap_h" },
			],

			states :
			{
				floor_h : null,
				underground_h : null,
				wall_k : null,
				overlap_h : null
			},

			okDisabled : true
		}
	},

	methods :
	{
		check_number(value)
		{
			return api.check_number({ value, gt : 0 })
		},

		check()
		{
			this.functional_sub_group_state = !!this.data.functional_sub_group

			this.okDisabled =
				Object.keys(this.data).length < 5
				|| !this.functional_sub_group_state
				|| Object.values(this.data).includes(undefined)
				|| Object.values(this.states).includes(false)

			return this.functional_sub_group_state
		},

		formatter(field, value)
		{
			if (value === "" || Number(value) === 0 || this.check_number(value))
			{
				return value
			}
			else
			{
				return this.data[field]
			}
		},

		validate(field, value)
		{
			this.check_number(value) ? this.states[field] = null : this.states[field] = false
			this.check()
		},

		reset()
		{
			this.data = {}
			this.functional_sub_group_state = null
			Object.keys(this.states).forEach((key) => this.states[key] = null)
		},

		execute()
		{
			this.$bvModal.show(this.id)
		},

		ok(event)
		{
			event.preventDefault()
			this.submit()
		},

		submit()
		{
			if(this.okDisabled)
				return

			this.data.floor_h = Number(this.data.floor_h)
			this.data.underground_h = Number(this.data.underground_h)
			this.data.wall_k = Number(this.data.wall_k)
			this.data.overlap_h = Number(this.data.overlap_h)

			api.call(this, this.service, "add", { data : this.data },
				() =>
				{
					this.$parent.refresh()
					this.$nextTick(() => { this.$bvModal.hide(this.id, "modal-prevent-closing") })
				})
		}
	}
}

</script>

<style>
.floor-height_add .form-group > div
{
    position: relative;
}

.floor-height_add .invalid-tooltip
{
    display: none;
    top: 1.625rem;
    left: unset;
    right: .5rem;
    background-color: var(--bft-neutral-900-tooltip);
    max-width: max-content;
}

.floor-height_add .form-control.is-invalid:hover + .invalid-tooltip
{
    display: block;
}
</style>
